import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Card from '../../../atoms/Card/Card';
import Menu from '../../../atoms/Menu/Menu';
import { addPublicURL } from '../../../Functions/AddPublicURL';
import { saveToLocalStorage } from '../../../Functions/LocalStorageUtils';
import { setControllerType } from '../../../redux/reducers/appReducer';
import { useAppDispatch, useAppSelector } from '../../../redux/store';

import styles from './TechSetting.module.scss';

const TechSetting: React.FC = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const tech = useAppSelector((state) => state.app.controllerType);


    const handleTechChange = () => {
        dispatch(setControllerType(''));
        saveToLocalStorage('tech', '');
        navigate('/');
    }

    return (
        <div className={styles.Container}>
            <div>
                <h2 className={styles.Heading}>{t('settings.tech_settings.heading')}</h2>
            </div>
            <Card width="36rem" padding="1.5rem">
                <Menu orientation="vertical">
                    <Menu.Item
                        key={'tech'}
                        variant="primary"
                        isactive={false}
                        onClick={() => handleTechChange()}
                    >
                        <Menu.ItemLeft>{t('settings.tech_settings.change_your_tech')}</Menu.ItemLeft>
                        <Menu.ItemRight><img src={addPublicURL(`/assets/inels_${tech}_logo.png`)} alt={tech} style={{ width: '4rem', height: '4rem' }}></img></Menu.ItemRight>
                    </Menu.Item>
                </Menu>
            </Card>
        </div>
    );
}

export default TechSetting;